import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { api, fmtDate, fmtTime, fmtDuration } from "../lib/api";

export default function Tickets() {
  const [status, setStatus] = useState("all");
  const [search, setSearch] = useState("");
  const [agentFilter, setAgentFilter] = useState("");
  const [agents, setAgents] = useState([]);
  const [tickets, setTickets] = useState([]);

  useEffect(() => { api.get("/agents").then((r) => setAgents(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    api.get("/tickets", { params: { status, search, agent_id: agentFilter } }).then((r) => setTickets(r.data));
  }, [status, search, agentFilter]);

  return (
    <div className="p-6 overflow-y-auto h-full" data-testid="tickets-page">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="font-heading font-extrabold text-2xl">Tickets</h2>
          <p className="font-script text-xl text-amber-800">one ticket per chat ✦</p>
        </div>
        <div className="flex gap-2 items-center flex-wrap">
          <div className="relative">
            <Search size={13} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-500" />
            <input data-testid="ticket-search-input" className="sd-input pl-8 py-1.5 text-xs" style={{ width: "14rem" }} placeholder="Search ticket #, customer…" value={search} onChange={(e) => setSearch(e.target.value)} />
          </div>
          <select data-testid="ticket-agent-filter" className="sd-input py-1.5 text-xs" style={{ width: "10rem" }} value={agentFilter} onChange={(e) => setAgentFilter(e.target.value)}>
            <option value="">All agents</option>
            {agents.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
          </select>
          {[["all", "All"], ["open", "Open"], ["sla", "SLA ⚠"], ["resolved", "Resolved"]].map(([s, label]) => (
            <button key={s} data-testid={`ticket-filter-${s}`} className={`filter-pill ${status === s ? "active" : ""}`} onClick={() => setStatus(s)}>{label}</button>
          ))}
        </div>
      </div>
      <div className="card-tactile overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left bg-[#FDF0A0] border-b-2 border-[#131E3A] font-heading text-xs uppercase tracking-wider">
              <th className="py-2.5 px-3">Ticket</th><th>Customer</th><th>Status</th><th>Agent</th><th>Created</th><th>Resolution</th><th>CSAT</th><th>QA</th><th>Closing remark</th>
            </tr>
          </thead>
          <tbody>
            {tickets.map((t) => (
              <tr key={t.id} data-testid={`ticket-row-${t.ticket_number}`} className="border-b border-dashed border-slate-300 hover:bg-[#FDF0A0]/40 cursor-pointer" onClick={() => window.open(`/?c=${t.id}`, "_blank")}>
                <td className="py-2.5 px-3 font-bold font-heading">{t.ticket_number}</td>
                <td>{t.customer_name}</td>
                <td>
                  <span className={`text-[11px] font-bold px-1.5 rounded border border-[#131E3A] ${t.status === "open" ? "bg-[#D4F0F0]" : "bg-[#E8DFF5]"}`}>{t.status}</span>
                  {t.status === "open" && Date.now() - new Date(t.created_at).getTime() > 48 * 3600 * 1000 && <span data-testid={`ticket-sla-${t.ticket_number}`} className="ml-1 text-[10px] font-bold px-1.5 rounded border border-red-600 bg-red-100 text-red-700">⚠ SLA</span>}
                  {t.status === "open" && Date.now() - new Date(t.created_at).getTime() > 36 * 3600 * 1000 && Date.now() - new Date(t.created_at).getTime() <= 48 * 3600 * 1000 && <span data-testid={`ticket-sla-risk-${t.ticket_number}`} className="ml-1 text-[10px] font-bold px-1.5 rounded border border-amber-600 bg-amber-100 text-amber-700">⏳ 36h+</span>}
                </td>
                <td>{t.assigned_name || <span className="text-red-600 text-xs font-semibold">unassigned</span>}</td>
                <td className="text-xs text-slate-600">{fmtDate(t.created_at)} {fmtTime(t.created_at)}</td>
                <td className="text-xs">{fmtDuration(t.resolution_seconds)}</td>
                <td className="text-xs text-amber-600">{t.csat_rating ? "★".repeat(t.csat_rating) : "—"}</td>
                <td className="text-xs text-purple-700" title={t.qa_remarks ? `${t.qa_remarks} — ${t.qa_by}` : undefined}>{t.qa_rating ? "★".repeat(t.qa_rating) : "—"}</td>
                <td className="text-xs text-slate-600">{t.closed_remark || "—"}</td>
              </tr>
            ))}
            {tickets.length === 0 && <tr><td colSpan={9} className="text-center py-8 font-script text-xl text-amber-800">no tickets yet…</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
